import { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { useShallow } from 'zustand/react/shallow'

import { DataCard } from '@/components/card'
import { FilterableTable } from '@/components/table/base'
import { TitleSetter } from '@/components/Title'
import { STORE_STATUS } from '@/constants/store'
import { useTournaments } from '@/stores/tournaments'
import { GolfTournamentWithFeedCount } from '@/stores/tournaments/tournaments.utils'

import { TOURNAMENTS_TABLE_COLUMNS, TOURNAMENTS_TABLE_FILTERS } from './tournaments.table'

export const TournamentsView = () => {
  const navigate = useNavigate()

  const { data, isLoading, isFetching, selectedFilters, fetchData, resetState, setFilters } =
    useTournaments(
      useShallow((state) => ({
        data: state.data,
        isLoading: state.status === STORE_STATUS.loading,
        isFetching: state.status === STORE_STATUS.fetching,
        selectedFilters: state.filters,
        fetchData: state.fetchData,
        resetState: state.resetState,
        setFilters: state.setFilters
      }))
    )

  useEffect(() => {
    fetchData()
    return resetState
  }, [])

  const handleClick = (row: GolfTournamentWithFeedCount) => {
    navigate(`./${row.id}`)
  }
  return (
    <>
      <TitleSetter title="Golf - Tournaments" />
      <DataCard title="Tournaments">
        <FilterableTable
          columns={TOURNAMENTS_TABLE_COLUMNS}
          filters={TOURNAMENTS_TABLE_FILTERS}
          data={data}
          loading={isLoading}
          disableColumnVisibility
          fetching={isFetching}
          clientSideSortAndPagination
          onFiltersChange={setFilters}
          selectedFilters={selectedFilters}
          onRowClick={handleClick}
          defaultSort={{
            attribute: 'id',
            order: 'asc'
          }}
        />
      </DataCard>
    </>
  )
}
